"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.IsEmpty = void 0;
// eslint-disable-next-line @typescript-eslint/no-explicit-any
class IsEmpty {
    constructor(childRenderer) {
        this.childRenderer = childRenderer;
    }
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    format(array, parameter) {
        return array.length === 0 ? this.childRenderer.default(parameter) : '';
    }
}
exports.IsEmpty = IsEmpty;
//# sourceMappingURL=is_empty.js.map